'use strict';

export default [
  'ResourceService',
  class SupportService {
    constructor(resourceService) {
      this._resourceService = resourceService;
      this._API_BASE = '/support';
    }

    sendMessage(name, email, category, message, _email, type) {
      // cant do !_email becuase it should be equal to '' unless its submitted by a scraper.
      if (!name || !email || !category || !message || _email == null) {
        return this._resourceService.errorPromise('support:sendMessage: missing parameters');
      }

      return this._resourceService.post(`${this._API_BASE}/contact-us`, {
        'name': name,
        'email': email,
        'category': category,
        'message': message,
        '_email': _email,
        'form_type': type
      });
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/api-services/support-service.js